import { type SxProps, type SxPropsArray } from '../../types/mui/sx';

export const sxPropsAreArray = (sx: SxProps): sx is SxPropsArray => Array.isArray(sx);
